import elmElement from '../elm_element'
import { Elm } from '../../elm/Carwow/MakeModelMenu.elm'
import { getUserIdFromJwtCookie } from '../jwt'
import modalPorts from '../modal'
import navigationPorts from '../navigation'
import Cookie from 'js-cookie'

function getUserTokenCookie () {
  if (!getUserIdFromJwtCookie()) return ''

  return Cookie.get('session_token')
}

elmElement('carwow-make-model-menu', Elm.Carwow.MakeModelMenu, {
  setupPorts (ports) {
    modalPorts(ports)
    navigationPorts(ports)
  },
  staticFlags: {
    location: window.location.href,
    jwt: getUserTokenCookie()
  },
  mapFlags (flags) {
    let promotionBadgeMakes = flags.promotionBadgeMakes || []
    let promotionBadgeModels = flags.promotionBadgeModels || []

    // Parse JSON arrays from HAML
    if (typeof promotionBadgeMakes === 'string') {
      try {
        promotionBadgeMakes = JSON.parse(promotionBadgeMakes)
      } catch (e) {
        promotionBadgeMakes = []
      }
    }

    if (typeof promotionBadgeModels === 'string') {
      try {
        promotionBadgeModels = JSON.parse(promotionBadgeModels)
      } catch (e) {
        promotionBadgeModels = []
      }
    }

    return Object.assign(flags, {
      openWithHash: flags.openWithHash || null,
      hideAds: flags.hideAds || 'false',
      promotionBadgeText: flags.promotionBadgeText || '',
      promotionBadgeColour: flags.promotionBadgeColour || 'green-light',
      promotionBadgeIcon: flags.promotionBadgeIcon || null,
      promotionBadgeIconColour: flags.promotionBadgeIconColour || null,
      promotionBadgeMakes: promotionBadgeMakes,
      promotionBadgeModels: promotionBadgeModels
    })
  }
})

if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
  window.Carwow.registerBugsnagVolumeError((error) => {
    const component = error.errorClass.includes('carwow-make-model-menu')

    const messages = [
      '@ MakesResponse',
      'Http.BadStatus: 400 @ RecommendationResponse',
      'Http.BadStatus: 503 @ RecommendationResponse',
      'Http.BadStatus: 504 @ RecommendationResponse',
      'Http.NetworkError @ RecommendationResponse',
      'Http.Timeout @ RecommendationResponse',
      'Http.BadStatus: 504 @ MakesResponse',
      'Http.NetworkError @ MakesResponse',
      'Http.Timeout @ MakesResponse',
      'Http.BadStatus: 503 @ ModelsResponse',
      'Http.BadStatus: 504 @ ModelsResponse',
      'Http.NetworkError @ ModelsResponse',
      'Http.Timeout @ ModelsResponse'
    ]
    const validError = messages.some(message => error.errorMessage.includes(message))
    return component && validError
  })
}
